import { Type } from './../../enums';
export const getUnixTypes = () => [
    Type.MINUTES,
    Type.HOURS,
    Type.DAY,
    Type.MONTH
];
